import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
} from '@angular/core';
import { Contact } from '@epicuro-next/models/contacts';

@Component({
  selector: 'atx-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContactListComponent {
  @ContentChild('contentOnTheRight', { static: false })
  protected contentOnTheRightTemplateRef?: TemplateRef<unknown>;

  @Input()
  public contacts: Contact[] = [];
  @Input() public hyperlinkEmail = false;

  protected trackById(_: number, contact: Contact): string {
    return contact.userId;
  }
}
